import React from 'react'

function InfoTwo() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal mb-5">
  <p className="headline-lg">Disponibilización del catálogo de objetos geográficos (xls) del CABA y el de IDERA como
  referencia.</p>
  </div>
  <div className="bg-dark d-flex justify-content-center align-items-center w-100 panel-horizontal">
    <a className="external link-white text-white" href="https://ideba.gba.gob.ar/sites/default/files/Descripcion_Catalogo_Objetos_IDERA__V2-1_Marzo_2023.pdf" target="_blank" rel="noopener noreferrer">Ver PDF</a>
  </div>
  </div>

  )
}

export default InfoTwo